import { DatePicker, Tooltip, message, Select as AntSelect } from "antd";
import Skeleton from "react-loading-skeleton";
import moment from "moment";
import React, { useEffect, useState, useMemo, useRef } from "react";
import TaskServices from "../../../Services/TaskServices";
import SocketService from "../../../Services/SocketService";
import DataParser from "../../../utlits/Dataparser";
import "react-loading-skeleton/dist/skeleton.css";
import UserProfile from "../../Reuseable/UserProfile..jsx";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import EmojiPicker from 'emoji-picker-react';
import { MentionsInput, Mention } from "react-mentions";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import DateField from "../../Reuseable/DateField";
import AssigneField from "../../Reuseable/AssigneField";
import LeadPendingField from "../../Reuseable/LeadPendingField";
import TaskNotesPopover from "./TaskNotesPopover";
import InlineSubtaskRow from "./InlineSubtaskRow";

const EditTask = (props) => {
  const {
    mid,
    EditId,
    labelledby,
    priority,
    statuses,
    taskOwner,
    reFreshData,

    // Parent Managed Props (Source of Truth)
    title,
    setTitle,
    description,
    setDescription,
    assignedTo,
    setAssignedTo,
    dueDate,
    setDueDate,
    periority,
    setPeriority,
    status,
    setStatus,
    approval,
    setApproval,
    TaskData,
    loading, // from parent fetch
    editLoading,

    userPermissions,
    TaskViewAttachment,
    setTaskViewAttachment,
    TaskNote,
    setTasKNote,
    handleAddSubtask
  } = props;

  // New Props for modernization
  const {
    isRecurring,
    setIsRecurring,
    recurringPeriod,
    setRecurringPeriod,
    recurringTime,
    setRecurringTime,
    recurringTotalCount,
    setRecurringTotalCount,
    recurringExcludeDays,
    setRecurringExcludeDays,
    parentDueDate,
  } = props;

  const companyId = DataParser.CompanyId();
  const companyIdentifier = DataParser.CompanyIdentifier();

  const STATUS_CONFIG = {
    "Complete": { bg: "#eafbec", color: "#1CB333", text: "Complete" },
    "Completed": { bg: "#eafbec", color: "#1CB333", text: "Completed" },
    "Pending": { bg: "#fef7e0", color: "#DFA70D", text: "Pending" },
    "In Progress": { bg: "#eef0fe", color: "#607EF9", text: "In Progress" },
    "In-Progress": { bg: "#eef0fe", color: "#607EF9", text: "In Progress" },
    "On Hold": { bg: "#e0fdf8", color: "#0DDFAB", text: "On Hold" },
    "On-Hold": { bg: "#e0fdf8", color: "#0DDFAB", text: "On Hold" },
    "Pending-Approval": { bg: "#ebebeb", color: "#1D1D1D", text: "Pending Approval" },
    "Pending Approval": { bg: "#ebebeb", color: "#1D1D1D", text: "Pending Approval" },
    "Rejected": { bg: "#ffebeb", color: "#FF0000", text: "Rejected" },
    "Cancelled": { bg: "#ebebeb", color: "#1D1D1D", text: "Cancelled" },
  };

  const getStatusBadge = (status) => {
    const s = STATUS_CONFIG[status] || { bg: "#f1f5f9", color: "#475569", text: status || "—" };
    return (
      <span style={{
        background: s.bg, color: s.color,
        padding: "4px 12px", borderRadius: "8px",
        fontSize: "13px", fontWeight: "600",
        whiteSpace: "nowrap", display: "inline-block",
      }}>{s.text}</span>
    );
  };

  const getPriorityBadge = (pId) => {
    const pObj = priority?.find(p => String(p.id) === String(pId));
    if (!pObj) return <span className="user-name-text">Priority</span>;

    // Use the dynamic color from the database
    const baseColor = pObj.color || "#A0A0A0";

    return (
      <span style={{
        background: `${baseColor}15`, // Light version of the color (15% opacity)
        color: baseColor,
        padding: "4px 12px", borderRadius: "8px",
        fontSize: "13px", fontWeight: "600",
        whiteSpace: "nowrap", display: "inline-block",
      }}>{pObj.name}</span>
    );
  };

  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [userSearchTerm, setUserSearchTerm] = useState("");
  const [isStatusMenuOpen, setIsStatusMenuOpen] = useState(false);
  const [isPriorityMenuOpen, setIsPriorityMenuOpen] = useState(false);
  const [isApprovalMenuOpen, setIsApprovalMenuOpen] = useState(false);
  const [isRecurringMenuOpen, setIsRecurringMenuOpen] = useState(false);
  const [isRecurrencePeriodMenuOpen, setIsRecurrencePeriodMenuOpen] = useState(false);
  const [showAllAttachments, setShowAllAttachments] = useState(false);
  const [inlineSubtaskParentId, setInlineSubtaskParentId] = useState(null);
  const MODAL_COL = { created: '110px', assigned: '110px', date: '90px', status: '110px', comment: '0px', project: '44px' };

  // Description Modernization State
  const [isDescFocused, setIsDescFocused] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [showLinkInput, setShowLinkInput] = useState(false);
  const [linkUrl, setLinkUrl] = useState("");
  const quillRef = useRef(null);
  const clickedLinkRef = useRef({ index: null, length: null });
  const fileInputRef = useRef(null);
  const [attachUploadLoading, setAttachUploadLoading] = useState(false);
  const notePath = process.env.REACT_APP_NOTES_PATH || "https://crm.plan-it.xyz/public/uploads/notes/";

  const handleAttachmentUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setAttachUploadLoading(true);
    const tempId = `temp-${Date.now()}`;
    setTaskViewAttachment(prev => [...(prev || []), { id: tempId, attachment: file.name, original_name: file.name, _isUploading: true }]);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('company_id', companyId);
    formData.append('company_identifier', companyIdentifier);
    TaskServices.createTaskAttatchment(EditId, formData)
      .then(() => {
        message.success('Attachment uploaded');
        if (props.fetchTaskDetails) props.fetchTaskDetails(EditId);
      })
      .catch(() => { setTaskViewAttachment(prev => (prev || []).filter(f => f.id !== tempId)); message.error('Upload failed'); })
      .finally(() => { setAttachUploadLoading(false); e.target.value = ''; });
  };

  const handleAttachmentDelete = (file) => {
    setTaskViewAttachment(prev => (prev || []).filter(f => f.id !== file.id));
    const body = { company_id: companyId, company_identifier: companyIdentifier };
    TaskServices.deleteTaskAttachment(file.id, body)
      .then(() => message.success('Attachment removed'))
      .catch(() => { setTaskViewAttachment(prev => [...(prev || []), file]); message.error('Delete failed'); });
  };

  // Reset all local UI state whenever the task being viewed changes
  useEffect(() => {
    setIsUserMenuOpen(false);
    setIsStatusMenuOpen(false);
    setIsPriorityMenuOpen(false);
    setIsApprovalMenuOpen(false);
    setIsRecurringMenuOpen(false);
    setIsRecurrencePeriodMenuOpen(false);
    setIsDescFocused(false);
    setShowEmojiPicker(false);
    setShowLinkInput(false);
    setLinkUrl("");
    setUserSearchTerm("");
    setAttachUploadLoading(false);
    setInlineSubtaskParentId(null);
  }, [EditId]);

  // Socket listener — refresh task details when this task or its subtasks change
  useEffect(() => {
    if (!EditId) return;
    SocketService.connect();

    const handleTaskUpdate = (payload) => {
      if (String(payload.company_id) !== String(companyId)) return;
      const { action, data } = payload;
      const taskId = data?.id;
      const parentId = data?.parent_id;

      const affectsThisTask =
        String(taskId) === String(EditId) ||
        String(parentId) === String(EditId);

      if (affectsThisTask && props.fetchTaskDetails) {
        props.fetchTaskDetails(EditId);
      }
    };

    SocketService.on("task_update", handleTaskUpdate);
    return () => { SocketService.off("task_update", handleTaskUpdate); };
  }, [EditId, companyId]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.user-select-container-edit') &&
        !event.target.closest('.status-select-container-edit') &&
        !event.target.closest('.priority-select-container-edit') &&
        !event.target.closest('.approval-select-container-edit') &&
        !event.target.closest('.recurring-select-container-edit')) {
        setIsUserMenuOpen(false);
        setIsStatusMenuOpen(false);
        setIsPriorityMenuOpen(false);
        setIsApprovalMenuOpen(false);
        setIsRecurringMenuOpen(false);
        setIsRecurrencePeriodMenuOpen(false);
        setUserSearchTerm("");
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleUpdate = () => {
    if (parentDueDate && dueDate && moment(dueDate).isAfter(moment(parentDueDate), 'day')) {
      message.error(`Subtask due date cannot exceed parent task due date (${moment(parentDueDate).format("MMM D, YYYY")})`);
      return;
    }
    const body = {
      company_id: companyId,
      company_identifier: companyIdentifier,
      title: title,
      description: description,
      assign_to: assignedTo,
      due_date: moment(dueDate).format("YYYY-MM-DD"),
      priority: periority,
      status: status,
      recurring_period: recurringPeriod,
      recurring_time: recurringTime,
      recurringTotalCount: recurringTotalCount,
      recurring_exclude_days: recurringExcludeDays || [],
      approval_required: approval,
    };
    TaskServices.updateTask(EditId, body)
      .then(() => {
        message.success("Task updated");
        if (props.fetchTaskDetails) props.fetchTaskDetails(EditId);
      })
      .catch(() => message.error("Update failed"));
  };

  const isTaskComplete = status === 'Complete' || status === 'Completed';
  const isEditable = !!TaskData?.can_edit && !isTaskComplete;

  // When the creator adds a note to a completed task, auto-move it back to In Progress
  const handleNoteAdded = () => {
    if (isTaskComplete && !!TaskData?.can_edit) {
      const newStatus = 'In Progress';
      setStatus(newStatus);
      TaskServices.updateTaskStatus(EditId, {
        company_id: companyId,
        company_identifier: companyIdentifier,
        status: newStatus,
      }).catch(() => { });
    }
  };
  const assignedToUserObj = TaskData?.task_assigned_to || TaskData?.asignedd_to;
  const assignedToName = assignedToUserObj
    ? `${assignedToUserObj.first_name || ""} ${assignedToUserObj.last_name || ""}`.trim()
    : "";

  return (
    <>
      <style>
        {`
        .edit-task-modal-overlay {
          position: fixed; top: 0; left: 0; width: 100%; height: 100%;
          background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center;
          z-index: 100010; backdrop-filter: blur(4px);
        }
        .edit-task-container {
          width: 95%; max-width: 1200px; height: 95vh; height: calc(var(--app-vh, 100vh) * 0.95);
          background: #fff; border-radius: 24px; display: flex; overflow: hidden;
          box-shadow: 0 20px 60px rgba(0,0,0,0.15);
        }
        .edit-left-panel { flex: 0 0 68%; min-width: 0; display: flex; flex-direction: column; overflow: hidden; border-right: 1px solid #F0F0F0; }
        .edit-left-scroll { flex: 1; display: flex; flex-direction: column; overflow: hidden; padding: 15px 30px 16px 30px; }
        .subtask-list-container {
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
          padding-right: 4px;
        }
        .subtask-list-container::-webkit-scrollbar {
          width: 6px;
        }
        .subtask-list-container::-webkit-scrollbar-track {
          background: transparent;
        }
        .subtask-list-container::-webkit-scrollbar-thumb {
          background: #e4e4e7;
          border-radius: 3px;
        }
        .subtask-list-container::-webkit-scrollbar-thumb:hover {
          background: #d4d4d8;
        }
        .edit-right-panel { flex: 0 0 32%; min-width: 0; display: flex; flex-direction: column; background: #fff; padding: 24px; overflow: hidden; }
        .task-title-float-wrap-edit { position: relative; margin-bottom: 12px; }
        .task-title-float-wrap-edit textarea {
          border-radius: 12px !important; min-height: 44px !important; padding: 10px 0 !important;
          font-size: 17px !important; font-weight: 500 !important; border: 1.5px solid transparent !important;
          transition: border-color 0.2s ease, padding 0.2s ease !important; width: 100%; color: #1D1D1D; background: transparent !important;
          resize: none; overflow: hidden; line-height: 1.4;
          word-break: break-word; overflow-wrap: anywhere;
          display: block; box-sizing: border-box; font-family: inherit;
        }
        .task-title-float-wrap-edit textarea::placeholder {
          color: #a0a0a0 !important;
          font-size: 17px !important;
          font-weight: 500 !important;
        }
        .task-title-float-wrap-edit textarea:focus, .task-title-float-wrap-edit textarea:hover { border-color: #1D1D1D !important; padding-left: 16px !important; padding-right: 16px !important; outline: none !important; box-shadow: none !important; }
        .task-title-float-wrap-edit textarea:focus { border-color: #1D1D1D !important; }
        .task-title-float-wrap-edit label {
          position: absolute; left: 16px !important; top: 14px !important;
          font-size: 17px !important; opacity: 0 !important; transition: all 0.2s ease !important;
          pointer-events: none; color: #a0a0a0; background: #fff !important; z-index: 99 !important; padding: 0 4px;
        }
        .task-title-float-wrap-edit textarea:focus ~ label {
          top: 0 !important; transform: translateY(-50%); left: 12px !important;
          font-size: 12px !important; opacity: 1 !important; background: #fff !important; padding: 0 4px; color: #1D1D1D; z-index: 99 !important;
        }
        .meta-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0px 30px; margin-bottom: 6px; padding-right: 10px; }
        .meta-item { display: flex; align-items: center; gap: 12px; min-height: 26px; }
        .meta-label-wrap { display: flex; align-items: center; gap: 10px; width: 155px; white-space: nowrap; }
        .meta-label-icon { font-size: 18px; color: #A0A0A0; }
        .meta-label { font-size: 13px; color: #A0A0A0; font-weight: 500; }
        .meta-value { flex: 1; display: flex; align-items: center; }
        .user-badge-teal { background: #0DDFAB; color: #fff; width: 20px; height: 20px; border-radius: 4px; display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 9px; margin-right: 8px; }
        .user-name-text { font-size: 13px; font-weight: 400; color: #1D1D1D; }
        .section-header { font-size: 16px; font-weight: 700; color: #1D1D1D; margin: 8px 0 10px 0; }
        .modal-close-icon-btn { position: absolute; top: 20px; right: 20px; background: transparent; border: none; font-size: 24px; color: #A0A0A0; cursor: pointer; z-index: 10010; padding: 5px; border-radius: 50%; }
        .modal-close-icon-btn:hover { color: #1D1D1D; background: #F8F8F8; }
        .offcanvas.edit-task-modal-overlay { visibility: visible !important; background: rgba(0,0,0,0.5) !important; width: 100% !important; height: 100% !important; transform: none !important; border: none !important; display: none; align-items: center; justify-content: center; backdrop-filter: blur(4px); transition: none !important; z-index: 100010 !important; }
        .offcanvas.edit-task-modal-overlay.show { display: flex !important; }
        .action-select-plain { border: 1.5px solid transparent; background: transparent; font-size: 13px; font-weight: 400; color: #1D1D1D; padding: 2px 0; outline: none; cursor: pointer; width: 100%; }
        .action-select-plain:hover { border-bottom-color: #1D1D1D; }
        .listing-table-mini { width: 100%; border-collapse: separate; border-spacing: 0; }
        .listing-table-mini th { font-size: 11px; text-transform: uppercase; color: #A0A0A0; padding: 8px; border-bottom: 1px solid #F0F0F0; font-weight: 600; text-align: left; }
        .listing-table-mini td { padding: 12px 8px; font-size: 13px; border-bottom: 1px solid #F8F8F8; }

        .custom-user-dropdown { position: absolute; top: 100%; left: 0; width: 250px; background: #fff; border: 1px solid #E8E8E8; border-radius: 10px; box-shadow: 0 10px 30px rgba(0,0,0,0.1); z-index: 10000; margin-top: 5px; overflow: hidden; }
        .search-header { padding: 12px 16px; border-bottom: 1px solid #F0F0F0; display: flex; align-items: center; gap: 12px; }
        .search-header i { font-size: 18px; color: #1a1a1a; }
        .search-header input { border: none !important; outline: none !important; box-shadow: none !important; font-size: 14px; width: 100%; color: #1D1D1D; }
        .user-list-scroll { padding: 5px; max-height: 250px; overflow-y: auto; }
        .user-option-item { display: flex; align-items: center; gap: 10px; padding: 6px 10px; border-radius: 6px; cursor: pointer; transition: all 0.2s ease; font-size: 11px; color: #1a1a1a; }
        .user-option-item:hover { background: #F5F5F5; }
        .user-avatar-mini { width: 20px; height: 20px; background-color: #0DDFAB; color: #fff; border-radius: 4px; display: flex; align-items: center; justify-content: center; font-size: 9px; font-weight: 700; }
        .action-btn-wrap-edit { border: none; border-radius: 8px; padding: 2px 0; display: flex; align-items: center; gap: 6px; cursor: pointer; transition: all 0.2s ease; min-height: 26px; background: transparent; white-space: nowrap; }
        
        .btn-save-edit { background: #0DDFAB; color: #fff; border: none; padding: 8px 24px; border-radius: 8px; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
        .btn-save-edit:hover { background: #0bc598; }
        .btn-save-edit:disabled { opacity: 0.6; cursor: not-allowed; }

        .status-badge-edit { display: inline-flex; align-items: center; cursor: pointer; transition: all 0.2s ease; }
        .status-badge-edit:hover { opacity: 0.8; }
        .priority-badge-edit { display: inline-flex; align-items: center; cursor: pointer; transition: all 0.2s ease; }
        .priority-badge-edit:hover { opacity: 0.8; }
        
        .custom-status-dropdown, .custom-priority-dropdown-edit { position: absolute; top: 100%; right: 0; width: 170px; background: #fff; border: 1px solid #E8E8E8; border-radius: 10px; box-shadow: 0 10px 30px rgba(0,0,0,0.1); z-index: 10000; margin-top: 5px; overflow: hidden; padding: 5px; }
        .status-option-item, .priority-option-item-edit { padding: 8px 12px; border-radius: 6px; font-size: 13px; font-weight: 500; cursor: pointer; transition: all 0.2s; color: #1D1D1D; display: flex; align-items: center; gap: 10px; }
        .status-option-item:hover, .priority-option-item-edit:hover { background: #F5F5F5; }

        .custom-recurring-dropdown-edit { position: absolute; top: 100%; left: -130px; width: 260px; background: #fff; border: 1px solid #E8E8E8; border-radius: 12px; box-shadow: 0 10px 30px rgba(0,0,0,0.12); z-index: 10000; margin-top: 5px; }
        .recurring-menu-content { padding: 12px; }
        .recurring-section { margin-bottom: 4px; padding-bottom: 2px; border-bottom: 1px solid #F5F5F5; }
        .section-icon { font-size: 16px; color: #1D1D1D; }
        .section-label { font-size: 13px; font-weight: 600; color: #1D1D1D; }
        .recurring-custom-select-trigger, .recurring-inline-select, .recurring-inline-input, .recurring-inline-timepicker {
          width: 100%; border: none !important; outline: none !important; padding: 0 !important; font-size: 12px !important; background: transparent !important; cursor: pointer; font-weight: 500; margin-left: 26px; width: calc(100% - 26px);
        }
        .recurring-custom-select-trigger { display: flex; align-items: center; justify-content: space-between; height: 34px; }
        .custom-switch:checked { background-color: #0DDFAB !important; border-color: #0DDFAB !important; }

        /* Description Modernization CSS */
        .task-desc-float-wrap-edit {
          position: relative; border-radius: 12px; border: 1.5px solid transparent; transition: all 0.2s ease; margin-bottom: 20px; background: transparent;
        }
        .task-desc-float-wrap-edit:hover, .task-desc-float-wrap-edit.focused { border-color: #1D1D1D !important; background: #fff; }
        .task-desc-float-wrap-edit.focused { border-color: #1D1D1D !important; }
        .task-desc-float-wrap-edit .desc-icon {
          position: absolute; left: 16px; top: 13px !important; transform: none !important; font-size: 22px !important; color: #a0a0a0; transition: all 0.2s ease; pointer-events: none; z-index: 10;
        }
        .task-desc-float-wrap-edit.focused .desc-icon,
        .task-desc-float-wrap-edit.has-value .desc-icon {
          opacity: 0 !important;
        }
        .task-desc-float-wrap-edit label {
          position: absolute; left: 48px; top: 12px !important; font-size: 17px !important; line-height: 20px !important; color: #a0a0a0; transition: all 0.2s ease !important; pointer-events: none; z-index: 99 !important; transform: none !important; opacity: 1; background: #fff !important;
        }
        .task-desc-float-wrap-edit.focused label,
        .task-desc-float-wrap-edit.has-value label {
          top: 0 !important; transform: translateY(-50%) !important; left: 12px !important; font-size: 12px !important; opacity: 1 !important; background: #fff !important; padding: 0 4px; color: #1D1D1D; z-index: 99 !important;
        }
        .task-desc-float-wrap-edit.has-value:not(.focused) label {
          opacity: 0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
        }
        .ql-container.ql-snow { border: none !important; font-family: inherit !important; }
        .task-desc-float-wrap-edit .ql-editor { padding: 12px 0 !important; min-height: 44px !important; max-height: 200px !important; overflow-y: auto !important; font-size: 15px !important; transition: all 0.2s ease; margin-left: 0 !important; }
        .task-desc-float-wrap-edit .ql-editor p { margin-left: 0 !important; padding-left: 0 !important; }
        .task-desc-float-wrap-edit:hover .ql-editor, .task-desc-float-wrap-edit.focused .ql-editor { padding-left: 16px !important; padding-right: 16px !important; }
        .ql-editor.ql-blank::before {
          display: none !important;
        }

        .desc-toolbar {
          display: flex; gap: 4px; background: #F5F5F5; padding: 4px 8px; border-radius: 8px; width: fit-content; margin: 0 0 10px 16px;
          opacity: 0; visibility: hidden; transition: all 0.2s ease; border: none !important;
        }
        .task-desc-float-wrap-edit.focused .desc-toolbar { opacity: 1; visibility: visible; }
        .toolbar-btn {
          background: transparent !important; border: none !important; padding: 4px 8px !important; border-radius: 4px;
          color: #1D1D1D !important; font-size: 20px !important; display: flex !important; align-items: center !important; justify-content: center !important;
          transition: all 0.2s ease; cursor: pointer; width: 36px !important; height: 36px !important;
        }
        .toolbar-btn:hover { background: #E8E8E8 !important; }
        .link-popover {
          background: #fff; border: 1.5px solid #1D1D1D; border-radius: 10px; padding: 4px; bottom: 50px !important; left: 10px !important; width: 320px; box-shadow: 0 10px 25px rgba(0,0,0,0.1); z-index: 10001;
        }
        .link-apply-btn { background-color: #0DDFAB !important; border: none !important; color: #000 !important; font-weight: 600 !important; border-radius: 8px !important; padding: 6px 16px !important; font-size: 13px !important; }

        /* Stats Badges */
        .task-stats-row { display: flex; gap: 8px; margin-top: -10px; margin-bottom: 15px; }
        .stat-badge-dark { background: #1D1D1D; border-radius: 6px; padding: 2px 8px; display: flex; align-items: center; gap: 4px; cursor: default; transition: all 0.2s ease; }
        .stat-count-teal { color: #0DDFAB; font-size: 12px; font-weight: 400; }
        .stat-count-white { color: #FFFFFF; font-size: 12px; font-weight: 400; }
        .subtask-title { font-weight: 500; color: #111827; }
        .subtask-user-cell { display: flex; align-items: center; gap: 10px; }
        .subtask-user-name { font-weight: 500; color: #1D1D1D; font-size: 13px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 80px; }

        /* Attachment Styles */
        .attachment-footer-row { display: flex; align-items: center; justify-content: space-between; gap: 8px; margin-top: 8px; padding-top: 0; min-width: 0; }
        .attachment-footer-left { display: flex; align-items: center; gap: 8px; flex: 1; min-width: 0; flex-wrap: wrap; }
        .attachment-trigger-btn { display: flex; align-items: center; gap: 6px; background: #F5F5F5; border: 1.5px solid #E8E8E8; border-radius: 6px; padding: 3px 10px; cursor: pointer; white-space: nowrap; flex-shrink: 0; transition: all 0.2s ease; }
        .attachment-trigger-btn:hover { border-color: #1D1D1D; }
        .attachment-trigger-btn i { font-size: 13px; color: #6B7280; }
        .attachment-trigger-btn span { font-size: 11px; font-weight: 600; color: #6B7280; }
        .attachment-chips-wrap { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
        .attachment-count-badge { background: #E5E7EB; padding: 2px 8px; border-radius: 6px; display: flex; align-items: center; gap: 4px; color: #9CA3AF; font-size: 12px; font-weight: 700; }
        .attachment-chip { display: flex; align-items: center; gap: 6px; background: #1D1D1D; color: #0DDFAB; padding: 0 8px; height: 24px; border-radius: 4px; font-size: 11px; font-weight: 500; transition: all 0.2s ease; }
        .attachment-info { display: flex; align-items: center; gap: 6px; min-width: 0; text-decoration: none; cursor: pointer; overflow: hidden; }
        .attachment-name { color: #0DDFAB; font-size: 11px; font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 120px; }
        .attachment-icon { color: #0DDFAB; font-size: 12px; flex-shrink: 0; }
        .attachment-close { color: #0DDFAB; font-size: 13px; cursor: pointer; flex-shrink: 0; transition: transform 0.2s; }
        .attachment-close:hover { transform: scale(1.2); color: #fff; }
        .attachment-more-chip { display: flex; align-items: center; gap: 6px; background: #f8f9fa; border: 1px dashed #adb5bd; color: #1D1D1D; padding: 0 8px; height: 24px; border-radius: 4px; font-size: 11px; font-weight: 600; cursor: pointer; white-space: nowrap; flex-shrink: 0; transition: all 0.2s; }
        .attachment-more-chip:hover { border-color: #1D1D1D; }

        /* Tasks.jsx Structure Parity */
        .task-list-header-edit {
          display: flex; align-items: center; padding: 8px 0; background: #F2F2F2; overflow: hidden;
        }
        .task-list-header-edit span {
          font-size: 13px; font-weight: 600; color: #212529; text-align: left; display: block;
        }
        .task-row-edit {
          position: relative; display: flex; width: 100%; align-items: center; min-height: 44px; border: none; padding: 4px 0; transition: background-color 0.15s;
        }
        .task-row-edit:hover { background-color: #f9fafb !important; }
        .priority-indicator-edit {
          flex-shrink: 0; align-self: stretch; width: 4px;
          transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          display: flex; align-items: center; overflow: hidden;
          cursor: default; border-radius: 0 4px 4px 0;
        }
        .priority-indicator-edit:hover { width: 50px; box-shadow: 2px 0 8px rgba(0,0,0,0.1); }
        .priority-indicator-edit span {
          opacity: 0; transition: opacity 0.2s ease; white-space: nowrap;
          font-size: 10px; font-weight: 700; color: #1d1d1d; padding-left: 6px;
        }
        .priority-indicator-edit:hover span { opacity: 1; transition-delay: 0.1s; }
        .task-row-edit .subtask-row-actions { opacity: 0; visibility: hidden; transition: all 0.2s ease; }
        .task-row-edit:hover .subtask-row-actions { opacity: 1; visibility: visible; }
        .subtask-badge {
          font-size: 11px;
          color: #6b7280;
          background: #f3f4f6;
          padding: 1px 6px;
          border-radius: 4px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          gap: 3px;
          transition: all 0.2s ease;
          cursor: default;
        }
        .subtask-badge:hover {
          background: #1d1d1d !important;
          color: #ffffff !important;
        }
        .subtask-badge svg {
          flex-shrink: 0;
        }
        .subtask-badge:hover svg {
          stroke: #ffffff;
        }
        .subtask-badge:hover span {
          color: #ffffff;
        }
        `}
      </style>

      <div className="offcanvas offcanvas-end edit-task-modal-overlay" id={mid} onClick={() => props.onCloseDrawer?.()}>
        <div className="edit-task-container" style={{ position: "relative" }} onClick={(e) => e.stopPropagation()}>
          {TaskData && !props.openedFromParentModal && (
            <button
              className="modal-close-icon-btn"
              id="CloseTaskEdit"
              aria-label="Close"
              onClick={() => props.onCloseDrawer?.()}
            >
              <i className="uil uil-times" />
            </button>
          )}

          {loading ? (
            <div className="w-100 p-4">
                <Skeleton height={44} style={{ marginBottom: '16px' }} />
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                    <Skeleton height={44} />
                    <Skeleton height={44} />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                    <Skeleton height={44} />
                    <Skeleton height={44} />
                </div>
                <Skeleton height={44} style={{ marginBottom: '12px' }} />
                <Skeleton height={100} style={{ marginBottom: '12px' }} />
                <Skeleton count={3} height={40} style={{ marginBottom: '10px' }} />
            </div>
          ) : (
            <>
              <div className="edit-left-panel">
                <div className="edit-left-scroll">
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                    {!!(props.openedFromParentModal && TaskData?.parent_id && String(TaskData.parent_id) !== "0") && (
                      <button
                        onClick={() => props.onCloseDrawer?.()}
                        aria-label="Back to parent task"
                        style={{
                          background: '#fff', border: '1px solid #e2e8f0', padding: '0',
                          cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                          borderRadius: '6px', color: '#555', width: '26px', height: '26px', flexShrink: 0,
                        }}
                        onMouseEnter={e => { e.currentTarget.style.background = '#f8fafc'; e.currentTarget.style.borderColor = '#cbd5e1'; e.currentTarget.style.color = '#1D1D1D'; }}
                        onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.color = '#555'; }}
                      >
                        <i className="uil uil-angle-left" style={{ fontSize: '20px', lineHeight: '26px', display: 'block', height: '26px', textAlign: 'center' }} />
                      </button>
                    )}
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', background: '#0DDFAB', borderRadius: '6px', padding: '2px 8px' }}>
                      <span className="subtask-svg-icon" style={{ width: '13px', height: '13px', color: '#fff', mask: "url('/assets/images/subtask.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/subtask.svg') no-repeat center / contain" }} />
                      <span style={{ color: '#fff', fontSize: '11px', fontWeight: '700' }}>+{TaskData?.sub_tasks?.length || 0}</span>
                    </div>
                  </div>

                  {isEditable ? (
                    <div className="task-title-float-wrap-edit">
                      <textarea
                        id="taskTitleInputEdit"
                        placeholder="Enter a task title"
                        value={title}
                        rows={1}
                        onChange={(e) => {
                          setTitle(e.target.value);
                          e.target.style.height = 'auto';
                          e.target.style.height = e.target.scrollHeight + 'px';
                        }}
                        onFocus={(e) => { e.target.style.height = 'auto'; e.target.style.height = e.target.scrollHeight + 'px'; }}
                      />
                      <label htmlFor="taskTitleInputEdit">Enter a task title</label>
                    </div>
                  ) : (
                    <div className="task-title-float-wrap-edit">
                      <div style={{ fontSize: '24px', fontWeight: '500', color: '#1D1D1D', padding: '10px 0', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>{title}</div>
                    </div>
                  )}

                  <div className="meta-grid">
                    {/* Row 1 */}
                    <div className="meta-item">
                      <div className="meta-label-wrap">
                        <span style={{ display:'inline-block', width:'16px', height:'16px', flexShrink:0, backgroundColor: '#A0A0A0', mask:"url('/assets/images/assignedtomodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/assignedtomodal.svg') no-repeat center / contain", transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)', imageRendering: '-webkit-optimize-contrast' }} />
                        <span className="meta-label">Assigned to:</span>
                      </div>
                      <div className="meta-value">
                        {isEditable ? (
                          <div className="user-select-container-edit position-relative">
                            <div className="action-btn-wrap-edit" onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}>
                              {(() => {
                                const selectedUser = taskOwner?.find(u => String(u.id) === String(assignedTo));
                                const displayName = selectedUser
                                  ? (selectedUser.full_name || `${selectedUser.first_name || ""} ${selectedUser.last_name || ""}`.trim())
                                  : (assignedToName || "Assigned to");
                                const initials = displayName.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2) || "U";
                                return (
                                  <>
                                    <div className="user-badge-teal">{initials}</div>
                                    <span className="user-name-text">{displayName}</span>
                                  </>
                                );
                              })()}
                            </div>
                            {isUserMenuOpen && (
                              <div className="custom-user-dropdown">
                                <div className="search-header">
                                  <i className="uil uil-search" />
                                  <input autoFocus placeholder="Search..." value={userSearchTerm} onChange={(e) => setUserSearchTerm(e.target.value)} />
                                </div>
                                <div className="user-list-scroll">
                                  {(taskOwner || []).map(u => ({
                                    ...u,
                                    displayName: u.full_name || `${u.first_name || ""} ${u.last_name || ""}`.trim() || `User ${u.id}`
                                  })).filter(u => u.displayName.toLowerCase().includes(userSearchTerm.toLowerCase())).map(option => (
                                    <div key={option.id} className="user-option-item" onClick={() => { setAssignedTo(option.id); setIsUserMenuOpen(false); setUserSearchTerm(""); }}>
                                      <div className="user-avatar-mini">{option.displayName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)}</div>
                                      <span>{option.displayName}</span>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="d-flex align-items-center">
                            <div className="user-badge-teal">{(assignedToName || "U").split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2)}</div>
                            <span className="user-name-text">{assignedToName || "Unassigned"}</span>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="meta-item">
                      <div className="meta-label-wrap">
                        <span style={{ display:'inline-block', width:'16px', height:'16px', flexShrink:0, backgroundColor: '#A0A0A0', mask:"url('/assets/images/taskstatusmodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/taskstatusmodal.svg') no-repeat center / contain", transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)', imageRendering: '-webkit-optimize-contrast' }} />
                        <span className="meta-label">Task Status:</span>
                      </div>
                      <div className="meta-value">
                        <div className="status-select-container-edit position-relative">
                          <div className="status-badge-edit" onClick={() => setIsStatusMenuOpen(!isStatusMenuOpen)}>
                            {getStatusBadge(status)}
                          </div>
                          {isStatusMenuOpen && TaskData?.can_edit_status && (
                            <div className="custom-status-dropdown">
                              {statuses?.map(s => (
                                <div key={s} className="status-option-item" onClick={() => {
                                  setStatus(s);
                                  setIsStatusMenuOpen(false);
                                  if (!isEditable) {
                                    TaskServices.updateTaskStatus(EditId, {
                                      company_id: companyId,
                                      company_identifier: companyIdentifier,
                                      status: s,
                                    }).then((res) => {
                                      if (res.Good) {
                                        message.success(res.data || "Status updated");
                                        if (props.fetchTaskDetails) props.fetchTaskDetails(EditId);
                                      } else {
                                        setStatus(status);
                                        message.error(res.data || "Failed to update status");
                                      }
                                    }).catch((err) => {
                                      setStatus(status);
                                      message.error(err?.response?.data?.data || "Failed to update status");
                                    });
                                  }
                                }}>
                                  <span style={{ backgroundColor: STATUS_CONFIG[s]?.color, width: '8px', height: '8px', borderRadius: '50%' }} />
                                  {s}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Row 2 */}
                    <div className="meta-item">
                      <div className="meta-label-wrap">
                        <span style={{ display:'inline-block', width:'16px', height:'16px', flexShrink:0, backgroundColor: '#A0A0A0', mask:"url('/assets/images/duedatemodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/duedatemodal.svg') no-repeat center / contain", transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)', imageRendering: '-webkit-optimize-contrast' }} />
                        <span className="meta-label">Due Date:</span>
                      </div>
                      <div className="meta-value">
                        {isEditable ? (
                          <DatePicker
                            bordered={false} className="p-0"
                            value={dueDate ? moment(dueDate) : null}
                            onChange={(date) => { setDueDate(date); }}
                            format="MMMM DD,"
                            style={{ fontSize: '13px', fontWeight: '400', color: '#1D1D1D', width: 'fit-content' }}
                            placeholder="Select Date" suffixIcon={null}
                            disabledDate={(current) => {
                              if (current && current < moment().startOf('day')) return true;
                              if (parentDueDate && current && current.isAfter(moment(parentDueDate).endOf('day'))) return true;
                              return false;
                            }}
                          />
                        ) : (
                          <span className="user-name-text">{dueDate ? moment(dueDate).format("MMMM DD,") : "No Due Date"}</span>
                        )}
                      </div>
                    </div>

                    <div className="meta-item">
                      <div className="meta-label-wrap">
                        <span style={{ display:'inline-block', width:'16px', height:'16px', flexShrink:0, backgroundColor: '#A0A0A0', mask:"url('/assets/images/recurringtaskmodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/recurringtaskmodal.svg') no-repeat center / contain", transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)', imageRendering: '-webkit-optimize-contrast' }} />
                        <span className="meta-label">Recurring Task:</span>
                      </div>
                      <div className="meta-value">
                        {isEditable ? (
                          <div className="recurring-select-container-edit position-relative">
                            <div className="action-btn-wrap-edit" onClick={() => setIsRecurringMenuOpen(!isRecurringMenuOpen)}>
                              <span style={{ fontSize: '13px', fontWeight: '400', color: '#1D1D1D' }}>
                                {isRecurring ? `${recurringPeriod ? recurringPeriod.charAt(0).toUpperCase() + recurringPeriod.slice(1) : 'Recurring'}, ${moment(recurringTime, "HH:mm").format("hh:mm A")}` : "No"}
                              </span>
                            </div>
                            {isRecurringMenuOpen && (
                              <div className="custom-recurring-dropdown-edit">
                                <div className="recurring-menu-content">
                                  <div className="d-flex align-items-center justify-content-between mb-1 pb-1 border-bottom">
                                    <span style={{ fontSize: '14px', fontWeight: '600', color: '#1D1D1D' }}>Enable Recurring</span>
                                    <div className="form-check form-switch m-0">
                                      <input className="form-check-input custom-switch" type="checkbox" checked={isRecurring} onChange={(e) => setIsRecurring(e.target.checked)} />
                                    </div>
                                  </div>
                                  {isRecurring && (
                                    <>
                                      <div className="recurring-section">
                                        <div className="d-flex align-items-center gap-2 mb-0">
                                          <span className="section-icon" style={{ display: 'inline-block', width: '15px', height: '15px', flexShrink: 0, backgroundColor: '#1D1D1D', mask: "url('/assets/images/recurringperiodmodal.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/recurringperiodmodal.svg') no-repeat center / contain" }} />
                                          <span className="section-label">Recurrence Period</span>
                                        </div>
                                        <div className="recurrence-period-select-container position-relative">
                                          <div className="recurring-custom-select-trigger" onClick={() => setIsRecurrencePeriodMenuOpen(!isRecurrencePeriodMenuOpen)}>
                                            <span>{recurringPeriod ? recurringPeriod.charAt(0).toUpperCase() + recurringPeriod.slice(1) : "+ Add Period"}</span>
                                            <i className={`uil uil-angle-down`} />
                                          </div>
                                          {isRecurrencePeriodMenuOpen && (
                                            <div className="custom-priority-dropdown" style={{ width: '100%', left: '0', top: '100%' }}>
                                              <div className="priority-list-scroll">
                                                {["daily", "weekly", "monthly", "annually"].map(p => (
                                                  <div key={p} className="priority-option-item" onClick={() => { setRecurringPeriod(p); setIsRecurrencePeriodMenuOpen(false); }}>{p.charAt(0).toUpperCase() + p.slice(1)}</div>
                                                ))}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      {/* Exclude Days — only shown when Daily is selected */}
                                      {recurringPeriod === "daily" && (
                                        <div className="recurring-section">
                                          <div className="d-flex align-items-center gap-2 mb-1">
                                            <i className="uil uil-ban section-icon" />
                                            <span className="section-label">Exclude Days</span>
                                          </div>
                                          <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                                            {[
                                              { key: "monday", label: "Mon" },
                                              { key: "tuesday", label: "Tue" },
                                              { key: "wednesday", label: "Wed" },
                                              { key: "thursday", label: "Thu" },
                                              { key: "friday", label: "Fri" },
                                              { key: "saturday", label: "Sat" },
                                              { key: "sunday", label: "Sun" },
                                            ].map(({ key, label }) => {
                                              const isExcluded = (recurringExcludeDays || []).includes(key);
                                              return (
                                                <button
                                                  key={key}
                                                  type="button"
                                                  onClick={() => setRecurringExcludeDays(prev =>
                                                    isExcluded ? (prev || []).filter(d => d !== key) : [...(prev || []), key]
                                                  )}
                                                  style={{
                                                    padding: '3px 7px',
                                                    borderRadius: '6px',
                                                    border: `1px solid ${isExcluded ? '#1D1D1D' : '#E8E8E8'}`,
                                                    background: isExcluded ? '#1D1D1D' : '#fff',
                                                    color: isExcluded ? '#fff' : '#A0A0A0',
                                                    fontSize: '11px',
                                                    fontWeight: '600',
                                                    cursor: 'pointer',
                                                  }}
                                                >
                                                  {label}
                                                </button>
                                              );
                                            })}
                                          </div>
                                        </div>
                                      )}

                                      <div className="recurring-section">
                                        <div className="d-flex align-items-center gap-2 mb-1">
                                          <span className="section-icon" style={{ display: 'inline-block', width: '15px', height: '15px', flexShrink: 0, backgroundColor: '#1D1D1D', mask: "url('/assets/images/runtimemodal.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/runtimemodal.svg') no-repeat center / contain" }} />
                                          <span className="section-label">Run Time</span>
                                        </div>
                                        <input type="time" className="recurring-inline-timepicker" value={recurringTime} onChange={(e) => setRecurringTime(e.target.value)} />
                                      </div>
                                      <div className="recurring-section border-0 pb-0">
                                        <div className="d-flex align-items-center gap-2 mb-0">
                                          <span className="section-icon" style={{ display: 'inline-block', width: '15px', height: '15px', flexShrink: 0, backgroundColor: '#1D1D1D', mask: "url('/assets/images/recurrencesmodal.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/recurrencesmodal.svg') no-repeat center / contain" }} />
                                          <span className="section-label">No. of Recurrences</span>
                                        </div>
                                        <input
                                          type="number" className="recurring-inline-input" placeholder="+ Add No" value={recurringTotalCount || ""}
                                          onChange={(e) => setRecurringTotalCount(parseInt(e.target.value) || 0)}
                                        />
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <span style={{ fontSize: '13px', color: '#1D1D1D' }}>{isRecurring ? `${recurringPeriod ? recurringPeriod.charAt(0).toUpperCase() + recurringPeriod.slice(1) : ''}, ${recurringTime}` : "No"}</span>
                        )}
                      </div>
                    </div>

                    {/* Row 3 */}
                    <div className="meta-item">
                      <div className="meta-label-wrap">
                        <span style={{ display:'inline-block', width:'16px', height:'16px', flexShrink:0, backgroundColor: '#A0A0A0', mask:"url('/assets/images/prioritymodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/prioritymodal.svg') no-repeat center / contain", transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)', imageRendering: '-webkit-optimize-contrast' }} />
                        <span className="meta-label">Priority:</span>
                      </div>
                      <div className="meta-value">
                        <div className="priority-select-container-edit position-relative">
                          <div className="priority-badge-edit" onClick={() => isEditable && setIsPriorityMenuOpen(!isPriorityMenuOpen)} style={{ cursor: isEditable ? 'pointer' : 'default' }}>
                            {getPriorityBadge(periority)}
                          </div>
                          {isPriorityMenuOpen && isEditable && (
                            <div className="custom-priority-dropdown-edit">
                              {priority?.map(p => {
                                return (
                                  <div key={p.id} className="priority-option-item-edit" onClick={() => { setPeriority(p.id); setIsPriorityMenuOpen(false); }}>
                                    <span style={{ backgroundColor: p.color || '#A0A0A0', width: '8px', height: '8px', borderRadius: '50%' }} />
                                    {p.name}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="meta-item">
                      <div className="meta-label-wrap">
                        <span style={{ display:'inline-block', width: '16px', height: '16px', backgroundColor: '#A0A0A0', mask: "url('/assets/images/subtaskeditmodal.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/subtaskeditmodal.svg') no-repeat center / contain", transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)', imageRendering: '-webkit-optimize-contrast', flexShrink: 0 }} />
                        <span className="meta-label">Subtask:</span>
                      </div>
                      <div className="meta-value">
                        <span style={{
                          background: '#CCCCCC', color: '#FFFFFF',
                          padding: '4px 12px', borderRadius: '8px',
                          fontSize: '13px', fontWeight: '400',
                          display: 'flex', alignItems: 'center', gap: '6px'
                        }}>
                          <span className="subtask-svg-icon" style={{ width: '15px', height: '15px', mask: "url('/assets/images/subtask.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/subtask.svg') no-repeat center / contain" }} />
                          +{TaskData?.sub_tasks?.length || 0}
                        </span>
                      </div>
                    </div>

                    {/* Row 4 */}
                    <div className="meta-item">
                      <div className="meta-label-wrap">
                        <span style={{ display:'inline-block', width:'16px', height:'16px', flexShrink:0, backgroundColor: '#A0A0A0', mask:"url('/assets/images/approvalrequiredmodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/approvalrequiredmodal.svg') no-repeat center / contain", transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)', imageRendering: '-webkit-optimize-contrast' }} />
                        <span className="meta-label">Approval Required:</span>
                      </div>
                      <div className="meta-value">
                        <div className="approval-select-container-edit position-relative">
                          <div className="action-btn-wrap-edit" onClick={() => isEditable && setIsApprovalMenuOpen(!isApprovalMenuOpen)} style={{ cursor: isEditable ? 'pointer' : 'default' }}>
                            <span style={{ fontSize: '13px', fontWeight: '500', color: '#1D1D1D' }}>
                              {String(approval) === "1" ? "Yes" : "No"}
                            </span>
                          </div>
                          {isApprovalMenuOpen && isEditable && (
                            <div className="custom-priority-dropdown-edit" style={{ width: '120px' }}>
                              <div className="priority-list-scroll">
                                <div className="priority-option-item-edit" onClick={() => { setApproval(1); setIsApprovalMenuOpen(false); }}>Yes</div>
                                <div className="priority-option-item-edit" onClick={() => { setApproval(0); setIsApprovalMenuOpen(false); }}>No</div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`task-desc-float-wrap-edit ${isDescFocused || showLinkInput || showEmojiPicker ? 'focused' : ''} ${(description && description !== '<p><br></p>') ? 'has-value' : ''}`}
                    onClick={(e) => {
                      if (!isEditable) return;
                      const anchor = e.target.closest('a');
                      if (anchor && anchor.closest('.ql-editor')) {
                        e.preventDefault();
                        const url = anchor.getAttribute('href');
                        setLinkUrl(url);
                        setShowLinkInput(true);

                        const q = quillRef.current.getEditor();
                        const Quill = ReactQuill.Quill;
                        const blot = Quill.find(anchor);
                        if (blot) {
                          clickedLinkRef.current = {
                            index: q.getIndex(blot),
                            length: blot.length()
                          };
                        }
                      }
                    }}
                  >
                    <ReactQuill
                      ref={quillRef}
                      theme="snow"
                      placeholder=""
                      value={description}
                      onChange={isEditable ? setDescription : () => { }}
                      onFocus={() => { if (isEditable) setIsDescFocused(true); }}
                      onBlur={() => setIsDescFocused(false)}
                      modules={{ toolbar: false }}
                      readOnly={!isEditable}
                    />
                    <span className="desc-icon" style={{ display:'inline-block', width:'18px', height:'18px', flexShrink:0, backgroundColor: '#a0a0a0', mask:"url('/assets/images/descriptionmodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/descriptionmodal.svg') no-repeat center / contain" }} />
                    <label>Description</label>

                    {/* ── Custom Toolbar ──────────────────────────────── */}
                    {isEditable && <div className="desc-toolbar" onMouseDown={(e) => e.preventDefault()}>
                      <button type="button" className="toolbar-btn" onClick={() => {
                        const quill = quillRef.current.getEditor();
                        const format = quill.getFormat();
                        quill.format('bold', !format.bold);
                      }}>
                        <i className="uil uil-bold" />
                      </button>
                      <button type="button" className="toolbar-btn" onClick={() => {
                        const quill = quillRef.current.getEditor();
                        const format = quill.getFormat();
                        quill.format('italic', !format.italic);
                      }}>
                        <i className="uil uil-italic" />
                      </button>
                      <button type="button" className="toolbar-btn" onClick={() => {
                        const quill = quillRef.current.getEditor();
                        const format = quill.getFormat();
                        quill.format('underline', !format.underline);
                      }}>
                        <i className="uil uil-underline" />
                      </button>
                      <div className="position-relative">
                        <button type="button" className="toolbar-btn" onClick={() => setShowEmojiPicker(!showEmojiPicker)}>
                          <i className="uil uil-smile" />
                        </button>
                        {showEmojiPicker && (
                          <div className="position-absolute" style={{ top: '40px', left: '0', zIndex: 10000 }} onMouseDown={(e) => e.stopPropagation()}>
                            <EmojiPicker
                              onEmojiClick={(emojiData) => {
                                const quill = quillRef.current.getEditor();
                                const range = quill.getSelection();
                                if (range) {
                                  quill.insertText(range.index, emojiData.emoji);
                                } else {
                                  quill.insertText(quill.getLength(), emojiData.emoji);
                                }
                                setShowEmojiPicker(false);
                              }}
                              width={300}
                              height={400}
                            />
                          </div>
                        )}
                      </div>
                      <div className="position-relative">
                        <button type="button" className="toolbar-btn" onClick={() => {
                          const quill = quillRef.current.getEditor();
                          const format = quill.getFormat();
                          if (format.link) {
                            setLinkUrl(format.link);
                            const range = quill.getSelection();
                            if (range) {
                              const [leaf] = quill.getLeaf(range.index);
                              let blot = leaf;
                              const Quill = ReactQuill.Quill;
                              while (blot && blot.statics.blotName !== 'link' && blot !== quill.scroll) {
                                blot = blot.parent;
                              }
                              if (blot && blot.statics.blotName === 'link') {
                                clickedLinkRef.current = {
                                  index: quill.getIndex(blot),
                                  length: blot.length()
                                };
                              } else {
                                clickedLinkRef.current = { index: null, length: null };
                              }
                            }
                          } else {
                            setLinkUrl("");
                            clickedLinkRef.current = { index: null, length: null };
                          }
                          setShowLinkInput(!showLinkInput);
                        }}>
                          <i className="uil uil-link" />
                        </button>
                        {showLinkInput && (
                          <div className="position-absolute link-popover" onMouseDown={(e) => e.stopPropagation()}>
                            <div className="d-flex gap-2 align-items-center">
                              <input
                                type="text" className="form-control" placeholder="Paste or type a link..." value={linkUrl}
                                onChange={(e) => setLinkUrl(e.target.value)}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter') {
                                    const quill = quillRef.current.getEditor();
                                    const { index, length } = clickedLinkRef.current;
                                    if (index !== null && length !== null) {
                                      quill.formatText(index, length, 'link', linkUrl);
                                    } else {
                                      quill.format('link', linkUrl);
                                    }
                                    setShowLinkInput(false);
                                    setLinkUrl("");
                                    clickedLinkRef.current = { index: null, length: null };
                                  }
                                }}
                              />
                              {linkUrl && (
                                <a
                                  href={linkUrl.startsWith('http') ? linkUrl : `https://${linkUrl}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="toolbar-btn d-flex align-items-center justify-content-center"
                                  style={{ padding: '4px 8px', borderRadius: '6px', border: '1.5px solid #1D1D1D', color: '#1D1D1D', textDecoration: 'none', background: '#fff' }}
                                  title="Open link in new tab"
                                >
                                  <i className="uil uil-external-link-alt" style={{ fontSize: '18px' }} />
                                </a>
                              )}
                              {linkUrl && (
                                <button
                                  type="button"
                                  className="toolbar-btn d-flex align-items-center justify-content-center"
                                  style={{ padding: '4px 8px', borderRadius: '6px', border: '1.5px solid #ff4d4f', color: '#ff4d4f', background: '#fff' }}
                                  title="Remove link"
                                  onClick={() => {
                                    const quill = quillRef.current.getEditor();
                                    const { index, length } = clickedLinkRef.current;
                                    if (index !== null && length !== null) {
                                      quill.formatText(index, length, 'link', false);
                                    } else {
                                      quill.format('link', false);
                                    }
                                    setShowLinkInput(false);
                                    setLinkUrl("");
                                    clickedLinkRef.current = { index: null, length: null };
                                  }}
                                >
                                  <i className="uil uil-link-broken" style={{ fontSize: '18px' }} />
                                </button>
                              )}
                              <button
                                type="button" className="link-apply-btn"
                                onClick={() => {
                                  const quill = quillRef.current.getEditor();
                                  const { index, length } = clickedLinkRef.current;
                                  if (index !== null && length !== null) {
                                    quill.formatText(index, length, 'link', linkUrl);
                                  } else {
                                    quill.format('link', linkUrl);
                                  }
                                  setShowLinkInput(false);
                                  setLinkUrl("");
                                  clickedLinkRef.current = { index: null, length: null };
                                }}
                              >Apply</button>
                            </div>
                          </div>
                        )}
                      </div>
                      <button type="button" className="toolbar-btn" onClick={() => {
                        const quill = quillRef.current.getEditor();
                        const format = quill.getFormat();
                        quill.format('list', format.list === 'bullet' ? false : 'bullet');
                      }}>
                        <i className="uil uil-list-ul" />
                      </button>
                    </div>}
                  </div>

                  {/* Task Stats Badges */}
                  <div className="task-stats-row">
                    <div className="stat-badge-dark">
                      <span className="subtask-svg-icon" style={{ width: '15px', height: '15px', color: '#0DDFAB', mask: "url('/assets/images/subtask.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/subtask.svg') no-repeat center / contain" }} />
                      <span className="stat-count-teal">+{TaskData?.sub_tasks?.length || 0}</span>
                    </div>
                    <div className="stat-badge-dark">
                      <i className="uil uil-paperclip" style={{ color: '#fff', fontSize: '12px' }} />
                      <span className="stat-count-white">+{TaskViewAttachment?.length || 0}</span>
                    </div>
                  </div>

                  <div className="section-header" style={{ marginTop: '15px', marginBottom: '12px' }}>Subtask</div>

                  {/* 100% Mirror of Tasks.jsx Table Header but with reduced widths for Modal */}
                  <div className="task-list-header-edit">
                    <div style={{ flex: 1, minWidth: 0, paddingLeft: '36px', display: 'flex', alignItems: 'center' }}><span>Task Title</span></div>
                    <div style={{ width: '110px', flexShrink: 0, padding: '0 8px', display: 'flex', alignItems: 'center' }}><span>Created By</span></div>
                    <div style={{ width: '110px', flexShrink: 0, padding: '0 8px', display: 'flex', alignItems: 'center' }}><span>Assigned to</span></div>
                    <div style={{ width: '90px', flexShrink: 0, padding: '0 8px', display: 'flex', alignItems: 'center' }}><span>Due Date</span></div>
                    <div style={{ width: '140px', flexShrink: 0, padding: '0 6px', display: 'flex', alignItems: 'center' }}><span>Status</span></div>
                  </div>

                  <div className="subtask-list-container">
                    {TaskData?.sub_tasks?.length > 0 ? (
                      TaskData.sub_tasks.map(st => {
                        // Priority: try direct fields, then lookup by ID, then cross-ref allTasks
                        const findInAll = (tasks, id) => {
                          for (const t of (tasks || [])) {
                            if (String(t.id) === String(id)) return t;
                            const found = findInAll(t.sub_tasks, id);
                            if (found) return found;
                          }
                          return null;
                        };
                        const stFromAllTasks = findInAll(props.allTasks, st.id);
                        const stPriorityRaw = st.priority || st.periority || stFromAllTasks?.priority || stFromAllTasks?.periority;
                        const stPriorityId = stPriorityRaw && typeof stPriorityRaw === 'object' ? stPriorityRaw.id : stPriorityRaw;
                        const stPriority = priority?.find(p => String(p.id) === String(stPriorityId));
                        const stPriorityColor = stPriority?.color
                          || (stPriorityRaw && typeof stPriorityRaw === 'object' ? stPriorityRaw.color : null)
                          || st.priority_color
                          || stFromAllTasks?.priority_color;
                        const stPriorityName = stPriority?.name
                          || (stPriorityRaw && typeof stPriorityRaw === 'object' ? stPriorityRaw.name : null)
                          || st.priority_name
                          || stFromAllTasks?.priority_name;

                        // Backend sends creator as assignee_user (object) or assignee (overwritten to object)
                        const creatorUser = st.assignee_user || (st.assignee && typeof st.assignee === 'object' ? st.assignee : null);
                        const creatorId = creatorUser?.id;
                        const creatorObj = taskOwner?.find(u => String(u.id) === String(creatorId));
                        const creatorName = creatorObj
                          ? (creatorObj.full_name || `${creatorObj.first_name || ""} ${creatorObj.last_name || ""}`.trim())
                          : (creatorUser ? `${creatorUser.first_name || ""} ${creatorUser.last_name || ""}`.trim() || "—" : "—");

                        const assigneeUser = st.assignee_user || st.asignedd_to || st.assignee;
                        const assigneeObj = taskOwner?.find(u => String(u.id) === String(st.asigned_to)) || assigneeUser;
                        const assigneeName = assigneeObj
                          ? (assigneeObj.full_name || `${assigneeObj.first_name || ""} ${assigneeObj.last_name || ""}`.trim())
                          : (st.asigned_to_name || st.asigned_to_full_name || st.assignee_name || "Unassigned");

                        const canEdit = st.can_edit !== undefined ? !!st.can_edit : isEditable;
                        const canEditStatus = st.can_edit_status !== undefined ? !!st.can_edit_status : isEditable;

                        return (
                          <React.Fragment key={st.id}>
                          <div className="task-row-edit">
                            {stPriorityColor && (
                              <div className="priority-indicator-edit" style={{ backgroundColor: stPriorityColor }}>
                                <span>{stPriorityName}</span>
                              </div>
                            )}

                            {/* Task Title Column */}
                            <div style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: '8px', paddingLeft: stPriorityColor ? '8px' : '12px', paddingRight: '8px', overflow: 'hidden' }}>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                style={{ borderRadius: '5px', cursor: 'pointer', flexShrink: 0, margin: 0 }}
                                checked={st.status === 'Complete' || st.status === 'Completed'}
                                onChange={() => {
                                  const isComplete = st.status === 'Complete' || st.status === 'Completed';
                                  const newStatus = isComplete
                                    ? (statuses?.find(s => s !== 'Complete' && s !== 'Completed') || 'In Progress')
                                    : 'Complete';
                                  TaskServices.updateTaskStatus(st.id, {
                                    company_id: companyId,
                                    company_identifier: companyIdentifier,
                                    status: newStatus,
                                  }).then((res) => {
                                    if (res.Good) {
                                      message.success(res.data || "Status updated");
                                    } else {
                                      message.error(res.data || "Failed to update status");
                                    }
                                    if (props.fetchTaskDetails) props.fetchTaskDetails(EditId);
                                  })
                                    .catch(() => message.error("Failed to update subtask status"));
                                }}
                              />
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1, minWidth: 0, overflow: 'hidden' }}>
                                <div
                                  role="button"
                                  onClick={(e) => { e.stopPropagation(); if (props.handelDrawer) props.handelDrawer(e, st.id, true); }}
                                  style={{ cursor: 'pointer', minWidth: 0, overflow: 'hidden', flex: 1 }}
                                >
                                  {st.status === 'Complete' || st.status === 'Completed' ? (
                                    <del style={{ color: '#9ca3af', fontSize: '13px', fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', minWidth: 0 }}>
                                      {st.title}
                                    </del>
                                  ) : (
                                    <span style={{ color: '#111827', fontSize: '13px', fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', minWidth: 0 }}>
                                      {st.title}
                                    </span>
                                  )}
                                </div>
                                {st.subtask_count > 0 && (
                                  <div className="subtask-badge">
                                    <span className="subtask-svg-icon" style={{ width: '15px', height: '15px', mask: "url('/assets/images/subtask.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/subtask.svg') no-repeat center / contain" }} />
                                    <span style={{ fontWeight: '400' }}>+{st.subtask_count}</span>
                                  </div>
                                )}
                                {/* Hover Actions */}
                                <div className="subtask-row-actions" style={{ display: 'flex', alignItems: 'center', gap: '4px', marginLeft: '2px', flexShrink: 0 }}>
                                  {canEdit && (
                                    <Tooltip title="Add Subtask">
                                      <div
                                        onClick={(e) => { e.stopPropagation(); setInlineSubtaskParentId(st.id); }}
                                        style={{ width: '22px', height: '22px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px', background: '#f3f4f6', cursor: 'pointer', color: '#6b7280' }}
                                      >
                                        <i className="uil-plus" style={{ fontSize: '14px' }} />
                                      </div>
                                    </Tooltip>
                                  )}
                                  <Tooltip title="Edit Task">
                                    <div
                                      onClick={(e) => { e.stopPropagation(); if (props.handelDrawer) props.handelDrawer(e, st.id, true); }}
                                      style={{ width: '22px', height: '22px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px', background: '#f3f4f6', cursor: 'pointer', color: '#6b7280' }}
                                    >
                                      <i className="uil-edit-alt" style={{ fontSize: '14px' }} />
                                    </div>
                                  </Tooltip>
                                </div>
                              </div>
                            </div>

                            {/* Created By Column */}
                            <div style={{ width: '110px', flexShrink: 0, display: 'flex', alignItems: 'center', gap: '8px', overflow: 'hidden', padding: '0 8px' }}>
                              <UserProfile
                                username={creatorName}
                                userImage={creatorObj?.image || creatorUser?.image || st.creator_image}
                                style={{ width: '20px', height: '20px', flexShrink: 0, borderRadius: '4px' }}
                              />
                              <span className="subtask-user-name" style={{ fontSize: '11px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{creatorName}</span>
                            </div>

                            {/* Assigned to Column */}
                            <div style={{ width: '110px', flexShrink: 0, overflow: 'visible', padding: '0 8px', display: 'flex', alignItems: 'center' }}>
                              {canEdit ? (
                                <div style={{ width: '100%' }}>
                                  <AssigneField
                                    item={st}
                                    assigne={taskOwner}
                                    Services={TaskServices.updateTaskAssigne}
                                    Owner={assigneeObj}
                                    newOwner={st.asigned_to}
                                    data={null}
                                    reFreshData={null}
                                    localUpdate={() => props.fetchTaskDetails && props.fetchTaskDetails(EditId)}
                                    avatarSize="20px"
                                    bgColor="#0DDFAB"
                                    textColor="#1d1d1d"
                                    styles={{ fontSize: '11px' }}
                                  />
                                </div>
                              ) : (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', overflow: 'hidden' }}>
                                  <UserProfile
                                    username={assigneeName}
                                    userImage={assigneeObj?.image || st.assignee_image}
                                    style={{ width: '20px', height: '20px', flexShrink: 0, borderRadius: '4px' }}
                                  />
                                  <span className="subtask-user-name" style={{ fontSize: '11px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{assigneeName}</span>
                                </div>
                              )}
                            </div>

                            {/* Due Date Column */}
                            <div style={{ width: '90px', flexShrink: 0, overflow: 'hidden', padding: '0 8px', display: 'flex', alignItems: 'center' }}>
                              {canEdit ? (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                  <i className="uil-calendar-alt" style={{ fontSize: '18px', color: '#0DDFAB', flexShrink: 0 }} />
                                  <DateField
                                    item={st}
                                    defaultDate={st.due_date}
                                    Services={TaskServices.updateTaskDueDate}
                                    data={() => props.fetchTaskDetails && props.fetchTaskDetails(EditId)}
                                    styles={{ fontSize: '12px', color: '#1d1d1d', fontWeight: '500' }}
                                    suffixIcon={null}
                                    format="D, MMM"
                                    maxDate={dueDate}
                                  />
                                </div>
                              ) : (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                  <i className="uil-calendar-alt" style={{ fontSize: '18px', color: '#0DDFAB', flexShrink: 0 }} />
                                  <span style={{ fontSize: '12px', color: '#1d1d1d', fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {st.due_date ? moment(st.due_date).format('D, MMM') : '—'}
                                  </span>
                                </div>
                              )}
                            </div>

                            {/* Status Column */}
                            <div style={{ width: '140px', flexShrink: 0, overflow: 'visible', padding: '0 6px', display: 'flex', alignItems: 'center' }}>
                              {canEditStatus ? (
                                <div style={{ width: '100%' }}>
                                  <LeadPendingField
                                    item={st}
                                    Status={statuses}
                                    DefaultStatus={st.status}
                                    Services={TaskServices.updateTaskStatus}
                                    data={() => props.fetchTaskDetails && props.fetchTaskDetails(EditId)}
                                    fontSize="10px"
                                  />
                                </div>
                              ) : (
                                getStatusBadge(st.status)
                              )}
                            </div>
                          </div>
                          {inlineSubtaskParentId === st.id && (
                            <InlineSubtaskRow
                              parentTask={{ id: st.id, due_date: st.due_date, project_id: st.project_id || TaskData?.project_id }}
                              level={0}
                              taskOwner={taskOwner}
                              taskPriority={priority}
                              taskStatus={statuses}
                              companyId={companyId}
                              COL={MODAL_COL}
                              onCreated={() => { setInlineSubtaskParentId(null); if (props.fetchTaskDetails) props.fetchTaskDetails(EditId); }}
                              onCancel={() => { setInlineSubtaskParentId(null); }}
                            />
                          )}
                          </React.Fragment>
                        );
                      })
                    ) : null}

                    {inlineSubtaskParentId === EditId ? (
                      <InlineSubtaskRow
                        parentTask={{ id: EditId, due_date: dueDate, project_id: TaskData?.project_id }}
                        level={0}
                        taskOwner={taskOwner}
                        taskPriority={priority}
                        taskStatus={statuses}
                        companyId={companyId}
                        COL={MODAL_COL}
                        onCreated={() => { setInlineSubtaskParentId(null); if (props.fetchTaskDetails) props.fetchTaskDetails(EditId); }}
                        onCancel={() => { setInlineSubtaskParentId(null); }}
                      />
                    ) : (
                      <div
                        className="add-subtask-placeholder"
                        onClick={(e) => { e.stopPropagation(); setInlineSubtaskParentId(EditId); }}
                        style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 12px', cursor: 'pointer' }}
                      >
                        <div style={{ width: '18px', height: '18px', border: '1.5px solid #d1d5db', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9ca3af', flexShrink: 0 }}>
                          <i className="uil-plus" style={{ fontSize: '12px' }} />
                        </div>
                        <span style={{ color: '#9ca3af', fontSize: '11px', fontWeight: '400' }}>
                          Hit the enter for create a subtask
                        </span>
                      </div>
                    )}
                  </div>

                </div>{/* end edit-left-scroll */}

                {/* Attachments + Save Changes Footer Row — pinned to bottom */}
                <input ref={fileInputRef} type="file" style={{ display: 'none' }} onChange={handleAttachmentUpload} />
                <div className="attachment-footer-row" style={{ padding: '0 30px 16px 30px' }}>

                  {/* Left side: trigger icon + chips (flex-wrap) */}
                  <div className="attachment-footer-left">

                    {/* Paperclip trigger */}
                    <div
                      className="attachment-trigger-btn"
                      onClick={() => isEditable && fileInputRef.current?.click()}
                      style={{ cursor: isEditable ? 'pointer' : 'default', opacity: isEditable ? 1 : 0.5 }}
                    >
                      <span style={{ display:'inline-block', width: '16px', height: '16px', backgroundColor: '#6B7280', mask: "url('/assets/images/attachmentmodal.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/attachmentmodal.svg') no-repeat center / contain", transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)', imageRendering: '-webkit-optimize-contrast', flexShrink: 0 }} />
                      <span>Attachments</span>
                      {(TaskViewAttachment?.length || 0) > 0 && (
                        <span style={{
                          background: '#E5E7EB', borderRadius: '4px', padding: '0 5px',
                          fontSize: '10px', fontWeight: '700', color: '#6B7280', marginLeft: '2px'
                        }}>
                          +{TaskViewAttachment.length}
                        </span>
                      )}
                    </div>

                    {/* Chips + +N more — all inside the flex-wrap area */}
                    {(TaskViewAttachment?.length > 0) && (
                      <div className="attachment-chips-wrap">
                        {(showAllAttachments ? TaskViewAttachment : TaskViewAttachment.slice(0, 3)).map((file, idx) => (
                          <div key={file.id || idx} className="attachment-chip" style={{ opacity: file._isUploading ? 0.55 : 1 }}>
                            <a
                              href={file._isUploading || !file.attachment ? "#" : (notePath + file.attachment)}
                              target="_blank"
                              rel="noopener noreferrer"
                              download
                              className="attachment-info"
                              onClick={(e) => { if (file._isUploading || !file.attachment) e.preventDefault(); }}
                            >
                              <i className="uil-download-alt attachment-icon" />
                              <span className="attachment-name">
                                {(() => { const n = file.original_name || file.attachment || file.name || 'File'; return n.length > 15 ? n.substring(0, 12) + '...' + n.split('.').pop() : n; })()}
                              </span>
                            </a>
                            {file._isUploading ? (
                              <span style={{ color: '#0DDFAB', fontSize: '11px' }}>...</span>
                            ) : isEditable ? (
                              <i className="uil-multiply attachment-close" onClick={(e) => { e.stopPropagation(); handleAttachmentDelete(file); }} />
                            ) : null}
                          </div>
                        ))}
                        {/* +N more toggle — inside the wrap so it flows to next row with chips */}
                        {(TaskViewAttachment?.length || 0) > 3 && (
                          <div
                            className="attachment-more-chip"
                            onClick={() => setShowAllAttachments(!showAllAttachments)}
                          >
                            {showAllAttachments ? 'Show Less' : `+ ${TaskViewAttachment.length - 3} more`}
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Right side: Save Changes always pinned right */}
                  {isEditable && (
                    <button
                      className="btn-save-edit"
                      style={{ flexShrink: 0 }}
                      onClick={handleUpdate}
                      disabled={editLoading}
                    >
                      {editLoading ? 'Saving...' : 'Save Changes'}
                    </button>
                  )}
                </div>
              </div>

              <div className="edit-right-panel">
                <div className="comment-header" style={{ fontSize: '16px', fontWeight: '700', marginBottom: '15px' }}>Comments</div>

                <div className="flex-grow-1" style={{ minHeight: 0 }}>
                  <TaskNotesPopover
                    taskId={EditId}
                    localNotes={TaskNote || []}
                    setLocalNotes={setTasKNote}
                    mentionUsers={taskOwner?.map(u => ({ id: u.id, display: u.full_name || `${u.first_name} ${u.last_name}`.trim() }))}
                    currentUserId={DataParser.UserId()}
                    companyId={companyId}
                    isModal={true}
                    onNoteAdded={handleNoteAdded}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default EditTask;
